import classNames              from 'classnames';
import React, { FC }           from 'react';
import { Icon, SemanticICONS } from 'semantic-ui-react';

import { CorvalUIColor, Size } from '../../types';
import { StyledContainer }     from './StyledContainer';

export interface SidebarDeepContentBackBarProps {
	label: string,
	backDirection?: 'left' | 'right' | 'up' | 'down',
	
	onClick?(): void,
}

let defaultProps: SidebarDeepContentBackBarProps = {
	label:         'Back to Item',
	backDirection: 'left',
	onClick:       null,
};

const SidebarDeepContentBackBar: FC<SidebarDeepContentBackBarProps> = ( props ) => {
	
	return (
		<StyledContainer
			bgColor={ CorvalUIColor.WHITE }
			borderSize={ [ null, null, Size.SM, null ] }
			borderColor={ CorvalUIColor.DK_SCREEN_25 }
			padding={ Size.MD }
			onClick={ props.onClick }
			className={ classNames( {
				'cursor--pointer':      props.onClick ?? false,
				'opacity-hover--70':    props.onClick ?? false,
				'text--colored-purple': true,
			} ) }>
			
			<Icon name={ `chevron ${ props.backDirection }` as SemanticICONS } color={ 'purple' }/> { props.label }
		
		</StyledContainer>
	);
};

SidebarDeepContentBackBar.defaultProps = defaultProps;

export { SidebarDeepContentBackBar }
